var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.$pages),function(page){return _c('div',{key:page.number,staticClass:"page-list"},[_c('a',{on:{"click":function($event){return _vm.goToPage(page.number)}}},[_vm._v("page "+_vm._s(page.number))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }